/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const InfoCircleSolidIcon = ({
  className,
  style,
  color = '#009EFF',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M7.9745 0C3.79497 0 0.40625 3.58332 0.40625 8C0.40625 12.4193 3.79497 16 7.9745 16C12.154 16 15.5428 12.4193 15.5428 8C15.5428 3.58332 12.154 0 7.9745 0ZM7.9745 3.54839C8.68238 3.54839 9.25622 4.15497 9.25622 4.90323C9.25622 5.65148 8.68238 6.25806 7.9745 6.25806C7.26663 6.25806 6.69278 5.65148 6.69278 4.90323C6.69278 4.15497 7.26663 3.54839 7.9745 3.54839ZM9.68347 11.7419C9.68347 11.9557 9.5195 12.129 9.31726 12.129H6.63175C6.42951 12.129 6.26554 11.9557 6.26554 11.7419V10.9677C6.26554 10.754 6.42951 10.5806 6.63175 10.5806H6.99796V8.51613H6.63175C6.42951 8.51613 6.26554 8.34281 6.26554 8.12903V7.35484C6.26554 7.14106 6.42951 6.96774 6.63175 6.96774H8.58485C8.78708 6.96774 8.95105 7.14106 8.95105 7.35484V10.5806H9.31726C9.5195 10.5806 9.68347 10.754 9.68347 10.9677V11.7419Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="15.1365"
            height="16"
            fill="white"
            transform="translate(0.40625)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
